export default __webpack_public_path__ + "static/media/description-name.8c012b14.png";